// Approximate coordinates for the center of each region in Tanzania.
export const regionCoordinates = {
    "Arusha": { lat: -3.3869, lng: 36.6829 },
    "Dar es Salaam": { lat: -6.8000, lng: 39.2833 },
    "Dodoma": { lat: -6.1630, lng: 35.7516 },
    "Geita": { lat: -2.8714, lng: 32.2290 },
    "Iringa": { lat: -7.7667, lng: 35.7000 },
    "Kagera": { lat: -1.8833, lng: 31.4167 },
    "Katavi": { lat: -6.5000, lng: 31.0000 },
    "Kigoma": { lat: -4.8833, lng: 29.6333 },
    "Kilimanjaro": { lat: -3.3333, lng: 37.3333 },
    "Lindi": { lat: -10.0000, lng: 39.7167 },
    "Manyara": { lat: -4.7500, lng: 36.5000 },
    "Mara": { lat: -1.8333, lng: 34.0000 },
    "Mbeya": { lat: -8.9000, lng: 33.4500 },
    "Morogoro": { lat: -6.8333, lng: 37.6667 },
    "Mtwara": { lat: -10.2667, lng: 40.1833 },
    "Mwanza": { lat: -2.5167, lng: 32.9000 },
    "Njombe": { lat: -9.3333, lng: 34.7667 },
    "Pemba North": { lat: -5.0500, lng: 39.7667 },
    "Pemba South": { lat: -5.2500, lng: 39.7667 },
    "Pwani": { lat: -6.7833, lng: 38.9167 },
    "Rukwa": { lat: -7.9667, lng: 31.6167 },
    "Ruvuma": { lat: -10.6833, lng: 35.6500 },
    "Shinyanga": { lat: -3.6667, lng: 33.4167 },
    "Simiyu": { lat: -2.8500, lng: 34.0000 },
    "Singida": { lat: -4.8167, lng: 34.7500 },
    "Songwe": { lat: -8.7000, lng: 32.8000 },
    "Tabora": { lat: -5.0167, lng: 32.8000 },
    "Tanga": { lat: -5.0667, lng: 39.1000 },
    "Zanzibar North": { lat: -5.9000, lng: 39.2833 }, // Unguja North
    "Zanzibar South": { lat: -6.2833, lng: 39.4167 }, // Unguja South
    "Zanzibar West": { lat: -6.1950, lng: 39.2200 } // Mjini Magharibi
};
